"use client"

import { ActionCardDto } from "api"
import NextImage from "common/bit/NextImage"
import NextLink from "common/bit/NextLink"
import { trackActionsCtaClick } from "utils/gtm"
import {
  Card,
  CardSubtitle,
  CardTextWrapper,
  CardTitle,
  IconWrap,
} from "./actionsSection.styled"

/** Internal links start with "/" (NextLink for client-side nav); else external <a>. */
const isInternalUrl = (url?: string | null): boolean =>
  !!url && url.startsWith("/")

type Props = { card: ActionCardDto }

const ActionCard = ({ card }: Props) => {
  const clickable = !!card.cardUrl
  const as = clickable ? (isInternalUrl(card.cardUrl) ? NextLink : "a") : "div"

  return (
    <Card
      as={as}
      href={clickable ? card.cardUrl : undefined}
      $clickable={clickable}
      $displayOn={card.displayOn}
      onClick={
        clickable
          ? () => trackActionsCtaClick(card.cardTitle ?? "")
          : undefined
      }
    >
      {card.icon?.imageUrl && (
        <IconWrap>
          <NextImage image={card.icon} cover={false} ariaHidden />
        </IconWrap>
      )}
      <CardTextWrapper>
        {card.cardTitle && (
          <CardTitle className="action-title" dir="auto">
            {card.cardTitle}
          </CardTitle>
        )}
        {card.cardSubtitle && (
          <CardSubtitle dir="auto">{card.cardSubtitle}</CardSubtitle>
        )}
      </CardTextWrapper>
    </Card>
  )
}

export default ActionCard
